import { FC } from "react";
import styles from "./TitleText.module.css";


interface TitleComponentProps{
  title : string
  setAffiliateDetailsView? : any
}
const TitleText: FC<TitleComponentProps> = ({title}) => {
  return (
    <div className={styles.titleText}>
      <div className={styles.dashboard}>{title}</div>
    </div>
  );
};

export default TitleText;
